import { createRecipe } from './runtime.js';

const toggleButtonConfig = {"name":"toggleButton","defaultVariants":{"outline":false,"type":"text"},"variantMap":{"outline":["false","true"],"type":["icon_only","text"]}}

export const toggleButton = /* @__PURE__ */ createRecipe(toggleButtonConfig)